<template>
    <v-tooltip bottom>
        <v-select slot="activator"
            v-model="service"
            :items="serviceList"
            :label="$t('Service Type')"
            item-value="value"
            :hint="serviceHint"
            persistent-hint
        >
            <template slot="selection" slot-scope="{ item, selected }">
                {{ $t('ServiceType.' + item.value) }}
            </template>

            <template slot="item" slot-scope="{ item, tile }">
                <v-list-tile-avatar color="indigo" class="headline font-weight-light white--text">
                    {{ item.shortText }}
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title     v-text="$t('ServiceType.' + item.value)"></v-list-tile-title>
                    <v-list-tile-sub-title v-text="$t('ServiceType.' + item.value + '.explain')"></v-list-tile-sub-title>
                </v-list-tile-content>
            </template>
        </v-select>
        <span>{{ service ? $t('ServiceType.' + service + '.details')  : '' }}</span>
    </v-tooltip>
</template>

<script>
import { getDefaultServiceTypes } from "./util";

export default {
    name  : 'v-service-selector',
    props : ['value', 'type', 'is-city', 'allowed', 'max-days'],
    data() {
        return {
            service : ''
        };
    },

    computed : {
        serviceList : function() {
            let list = [];
            getDefaultServiceTypes().forEach(elem => {
                if ((
                    this.isCity ? elem.intracity : elem.intercity
                    ) && (
                    !elem.allowable ||
                    (elem.allowable && this.allowed && this.allowed[elem.value])
                   ) && (this.maxDays ? elem.maxDays : true)
                )
                {
                    list.push(elem);
                }
            });
            // add missing element to the list of available
            if (this.service && list.every(elem => elem.value !== this.service))
              list.push({ shortText: this.service.substring(0, 2).toUpperCase(), value: this.service});
            return list;
        },

        serviceHint : function() {
            if (this.service)
                return this.$t('ServiceType.' + this.service + '.explain');
            else
                return '';
        }
    },

    watch : {
        service : {
            handler(val) {
                this.$emit('input', val);
            }
        },
        value : {
            handler(val) {
                this.service = val;
            }
        },
        isCity : {
            handler(val) {
                this.setDefaultWhenNotInList();
            }
        },
        maxDays : {
            handler(val) {
                this.setDefault();
            }
      }
    },

    mounted() {
        this.service = this.value;
        this.setDefaultWhenNotInList();
    },

    methods: {
        setDefaultWhenNotInList() {
            if (this.serviceList.every(elem => elem.value !== this.service)) {
                let deflt = getDefaultServiceTypes().find(elem => this.isCity ? elem.cityDefault : elem.default);
                if (deflt) {
                    this.service = deflt.value;
                }
            }
        },
        setDefault() {            
            let deflt = getDefaultServiceTypes().find(elem => elem.default);
            if (deflt) {
                this.service = deflt.value;
            }            
        }
    }
}
</script>
